// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__9Kmxh","loader":"ContentLoader_loader__3af-X","disabled":"ContentLoader_disabled__L8wns"};